import { combineReducers } from "redux"

import creationReducer from "./creation/slice"
import deletionReducer from "./deletion/slice"

export const participantsStateReducer = combineReducers({
  creation: creationReducer,
  deletion: deletionReducer,
})
